import { drugsTypes } from '../types'

const initialState = {
  items: [],
  isRequesting: false,
  isError: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case drugsTypes.GET_DRUGS__REQUEST: return {
      ...state,
      isRequesting: true
    }
    case drugsTypes.GET_DRUGS__SUCCESS: return {
      ...state,
      isRequesting: false,
      items: action.payload.items
    }
    default:
      return state
  }
}
